import * as React from 'react';
import { Col, Row, Divider } from 'antd';

import General from './components/General';
import Values from './components/Values';
import Form from '../../../components/Form';
import { Title } from '../../../components/Layout/components';

interface IAttributeDetailProps {
  domain: string;
  attribute: GQL.IAttribute;
  languages: Array<GQL.ILanguage>;
  onSave: (attribute: GQL.IAttribute) => void;
  onCancel: () => void;
}

interface IAttributeDetailState {
  attribute: GQL.IAttribute;
  currentLanguage: string;
}

export default class AttributeDetail extends React.Component<IAttributeDetailProps, IAttributeDetailState> {

  public constructor(props: IAttributeDetailProps) {
    super(props);

    this.state = {
      attribute: props.attribute || {},
      currentLanguage: props.languages.map(l => l.value)[0],
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { languages } = this.props;
    const { attribute, currentLanguage } = this.state;

    return (
      <div>
        <Title
          languages={languages}
          currentLanguage={currentLanguage}
          onChange={(l: string) => { this.setState({ currentLanguage: l }); }}
        >
          {attribute
            ? `Attribute ${attribute.title ? `"${attribute.title}"` : ''}`
            : `Attributes`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row>
            <Col md={11}>
              <General
                attribute={attribute}
                currentLanguage={currentLanguage}
                onChange={this.onChange}
              />
            </Col>
            <Col md={12} offset={1}>
              <Values
                attribute={attribute}
                currentLanguage={currentLanguage}
                languages={languages}
                onChange={this.onChange}
              />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);
    const newValue = (language
      ? { [name]: { ...this.state.attribute[name], [language]: inputValue } }
      : { [name]: inputValue });
    this.setState({
      attribute: { ...this.state.attribute, ...newValue }
    });
  }

  private async save() {
    this.props.onSave(this.state.attribute);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Attributes/AttributeDetail/AttributeDetail.tsx